import React, { FC } from 'react'
import { Modal } from 'react-bootstrap'
import EditForm from './EditForm'

interface Props {
  open: boolean
  email: string
  handleClose: () => void
}

const EditContactModal: FC<Props> = props => {
  const { open, email, handleClose } = props
  return (
    <Modal
      show={open}
      onHide={(): void => handleClose()}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="maneuver_modal"
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">EDIT CONTACT</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <EditForm urlEmail={email} onSave={handleClose} />
      </Modal.Body>
    </Modal>
  )
}

export default EditContactModal
